import { RouterModule } from '@angular/router';
import { StaticPagesComponent } from 'pages/static-pages/static-pages.component';
import { TermsAndConditionsPageComponent } from 'pages/static-pages/term-and-conditions-page/term-and-conditions-page.component';
import { DisabledCookiesComponent } from './disabled-cookies/disabled-cookies.component';
import { disabledCookiesGuard } from './disabled-cookies/disabled-cookies.guard';

export const routing = RouterModule.forChild([
  {
    path: '',
    component: StaticPagesComponent,
    children: [
      {
        path: 'terms-and-conditions',
        component: TermsAndConditionsPageComponent,
      },
      {
        path: 'disabled-cookies',
        component: DisabledCookiesComponent,
        canActivate: [disabledCookiesGuard],
      },
    ],
  },
]);
